export default {
      id: "txt_strike-usage",
      viewBox: "0 0 18 16",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#txt_strike",
      toString: function () {
        return this.url;
      }
    }